/*
 * @Description:
 * @Date: 2021-10-20 11:43:02
 */
import BiTmplList from '../views/bi-tmpl-list.vue';
import BiTmplDetail from '../views/bi-tmpl-detail.vue';

export const route = [
  {
    path: '/main/bi-tmpl-list',
    name: 'bi-tmpl-list',
    meta: {
      title: 'BI模板管理'
    },
    component: BiTmplList
  },
  {
    path: '/main/bi-tmpl-detail',
    name: 'bi-tmpl-detail',
    meta: {
      title: '新增模板',
      parentPath: '/main/bi-tmpl-list'
    },
    component: BiTmplDetail
  }
];
